import { useState, useEffect, SyntheticEvent } from "react";

const KontaktForm: React.FC = () => {
  const [name, setName] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [message, setMessage] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<boolean>(false);
  const [showPopup, setShowPopup] = useState<boolean>(false);
  const CONTACT_API = "https://test.doctio.dk/api/contact";

  const handleSubmit = (e: SyntheticEvent) => {
    e.preventDefault();
    setError(null);
    setLoading(true);

    if (!name || !email || !message) {
      setShowPopup(true);
      setLoading(false);
      return;
    }

    const data = {
      name,
      email,
      text: message,
    };

    fetch(CONTACT_API, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((res) => {
        if (res.status === 200) {
          setLoading(false);
          setSuccess(true);
          setName("");
          setEmail("");
          setMessage("");
        } else {
          setLoading(false);
          setError(
            "Der er sket en fejl, og din besked kunne ikke blive sendt."
          );
        }
      })
      .catch((error) => {
        setLoading(false);
        setError("Der er sket en fejl, og din besked kunne ikke blive sendt.");
      });
  };

  useEffect(() => {
    if (success) {
      const timer = setTimeout(() => {
        setSuccess(false);
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [success]);

  useEffect(() => {
    if (showPopup) {
      const timer = setTimeout(() => {
        setShowPopup(false);
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [showPopup]);

  return (
    <section className="bg-white rounded-xl picture-shadow">
      <div id="kontakt-form" className="px-16 py-12 mx-auto">
        {showPopup && (
          <div
            className="p-4 mb-4 text-dsm text-red-800 shadow border border-red-300 rounded-lg bg-red-50"
            role="alert"
          >
            <span className="font-medium">Fejl.</span> Tjek indtastninger og
            prøv igen.
          </div>
        )}
        <h3>
          <a
            href="mailto:kontakt@doctio.dk"
            className="text-[2rem] md:text-[25px] font-bold text-center text-doctio-dark-green"
          >
            Email kontakt@doctio.dk
          </a>
        </h3>
        <p className="mb-8 mt-16 text-left text-dbase uppercase font-light text-doctio-green">
          Skriv en besked
        </p>
        <form className="space-y-6">
          <div>
            <input
              type="text"
              id="name"
              className="bg-white px-8 py-[5px] border border-[#E8E2DE] text-gray-900 text-[15px] rounded-lg focus:outline-none block w-full"
              placeholder="Navn"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
          </div>
          <div>
            <input
              type="email"
              className="block  w-full px-8 py-[5px] text-[15px] text-gray-900 bg-white rounded-lg border border-[#E8E2DE] focus:outline-none"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="sm:col-span-2">
            <textarea
              id="message"
              rows={4}
              className="block w-full px-8 py-[8px] text-[16px] text-gray-900 bg-white rounded-lg border border-[#E8E2DE] focus:outline-none"
              placeholder="Besked"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
            ></textarea>
          </div>
          <div className="flex justify-end">
            <button
              type="submit"
              onClick={handleSubmit}
              className="py-2 px-10  font-bold text-[17px] text-right text-white rounded-full bg-doctio-green sm:w-fit hover:bg-primary-800 focus:ring-4 focus:outline-none focus:ring-primary-300"
              disabled={loading}
            >
              {loading ? (
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.14,1.16a11,11,0,0,0-9,8.92A1.59,1.59,0,0,0,2.46,12,1.52,1.52,0,0,0,4.11,10.7a8,8,0,0,1,6.66-6.61A1.42,1.42,0,0,0,12,2.69h0A1.57,1.57,0,0,0,10.14,1.16Z"
                    className="spinner_P7sC"
                  />
                </svg>
              ) : (
                "Send"
              )}
            </button>
          </div>
        </form>
        {success && (
          <div className="text-doctio-green">
            Din besked blev sendt med succes!
          </div>
        )}
        {error && (
          <div className="text-red-800">
            Der er sket en fejl, og din besked kunne ikke blive sendt.
          </div>
        )}
      </div>
    </section>
  );
};

export default KontaktForm;
